const ENTER_KEY_CODE = 13;

const keyboardUtil = {
	onKeyDownInputEvent(event) {
		if (event.keyCode === ENTER_KEY_CODE) {
			const elements = document.querySelectorAll(`.js-key-focus-${ENTER_KEY_CODE}`);
			let found = false;
			elements.forEach((elem: any) => {
				if(!found) {
					if(elem === event.target) {
						found = true;
					}
				} else {
					if ((elem.tagName.toLowerCase() === 'input' || elem.tagName.toLowerCase() === 'textarea')) {
						elem.focus();
						found = false;
						return;
					}
				}
			});
		}
	},	
	onKeyDownCallback(e, codes: number[], callback) {
		const findCode = codes.find(el => el === e.keyCode);
		if(findCode) {
			callback();
		}
	}
}

export default keyboardUtil;